export default {
  BASENAME: process.env.REACT_APP_BASENAME || '',
};
